define('lib/services/batws',['lib/rest'], function (RestAPI) {
  var spec = {
    host: '/BATWS',
    apis: {
      geo: {
        url: '/geo/rest/',
        calls: {
          search: {
            url: 'searchMode/getDealerDetails/',
            dataType: 'json',
            headers: {
              Accept: 'application/json',
            },
            defaults: {
              begin: 1,
              end: 5,
            }
          },
          dealerDetails: {
            url: 'filterMode/getDealerDetails',
            dataType: 'json',
            defaults: {
              begin: 1,
              end: 1,
            }
          },
          getGeoInfo: {
            url: 'getLocation/getGeoInfo',
            dataType: 'json',
            defaults: {
              brand: '',
            }
          }
        }
      },

      // asUrl returns the URL directly (not currently in use)
      map: {
        url: '/map/',
        calls: {
          sign: {
            url: 'key/?url={url:https://maps.googleapis.com/maps/api/staticmap?center=USA&scale=2&size=400x400&zoom=5&format=png&maptype=roadmap&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8}',
          },
          asUrl: {
            generator: true,
            immediate: true,
            url: 'key/?url={url:https://maps.googleapis.com/maps/api/staticmap?center=USA&scale=2&size=400x400&zoom=5&format=png&maptype=roadmap&key=AIzaSyDs2iYTroHjB8l7zbfHyWUec2cpESSIVK8}',
          },
          static: {
            url: 'static',
            defaults: {
              query: '',
              redirect: false,
            }
          }
        }
      },

      // Lots of these return duplicate data. These are the calls we've all agreed could likely be culled down into many less calls
      // note: getSeriesTrimInfo also accepts a method of POST, with {trimInfoList: [{year: "2017", trimId: "5348"}]} (see OLD ajax-offers.js)
      cls: {
        url: '/cls/',
        calls: {
          getSeries: {
            dataType: 'json',
            url: 'getSeries.json',
            defaults: {
              lang: 'en'
            }
          },
          // required: {series_code: 'camry', year: '2017'}
          getSeriesTrimInfo: {
            dataType: 'json',
            url: '/getSeriesTrimInfo.json',
            defaults: {
              brand: 'toyota',
              key: 'XLzu5xh4YzCe6LeNpHVG',
              depth: 2
            }
          },

          getModel: {
            url: 'getModel/{raw!year}/{raw!series_code}.json'
          },

          getTrimInfo: {
            url: 'getTrimInfo/{raw!year}/{raw!series_code}/{raw!model}.json'
          },

          /*
          required: trimInfoList: [{year: '', trimId: ''}]
          Returns data about the specific trim requested:
          sample return: [{"modelName":"XLE","seriesCode":"sienna","seriesName":"Sienna","trimId":5348,"trimName":"Sienna XLE FWD 8-Passenger 3.5L V6","year":"2018"}]
            sample before function:
            before: function(reqConfig){
              reqCofing.data = JSON.stringify(reqConfig.data)
            },
          */
          postSeriesTrimInfo: {
            method: 'POST',
            stringify: true,
            contentType: 'application/json',
            dataType: 'json',
            url: '/getSeriesTrimInfo',
            defaults: {
              trimInfoList: [
                {
                  year: '2018',
                  trimId: '5348'
                }
              ]
            }
          }
          // taken from grepping BAT_ui
          /*
          getAllYearSeries: {},
          getModel: {},
          getTrimModel: {},
          getTrimInfo: {},
          getSeriesTrimInfo: {},
          getSeries: {}
          */
        }
      },

      slp: {
        url: '/slp/',
        calls: {
          getQuote: {
            url: 'getQuote',
            method: 'POST',
            defaults: {
              // customerFirstName: null,
              // customerLastName: null,
              // preferedContact: null, *!! NOTE SPELLING ERROR
              // customerEmail: null,
              // deviceType: null,
              // mediaTag: null,
              // omnitureId: null,
              // tmsSiteAttribute: null,
              // vehicleMake: null,
              // vehicleModel: null,
              // vehicleYear: null,
              // campaignCode: null,
              // dealerCode: null,
              // successPage: null,
              // errorPage: null

              /*
                MINIMUM SET OF PARAMS REQUIRED:
                customerFirstName
                customerLastName
                preferedContact
                customerEmail (if preferedContact is email )
                customerPhone ( if preferedContact is phone )
                successPage
                errorPage
                vehicleMake
                vehicleYear
                vehicleModel
                campaingCode
                dealerCode
                zip
              */
            }
          }
        }
      }

    }
  };

  return new RestAPI(spec);
});

